import { api } from '../../utils/api';

const getAllChannels = async () => {
	const channelRes = await api.get('/channels');

	return channelRes.data.channels;
};

const getUser = async (userId, userToken) => {
	const userInfo = await api.get(`/user?id=${userId}`, {
		headers: {
			'X-Access-Token': userToken
		}
	});

	return userInfo;
};

const getAccount = async (accountId, userToken) => {
	const accountInfo = await api.get(`/account?account_id=${accountId}`, {
		headers: {
			'X-Access-Token': userToken
		}
	});

	return accountInfo;
};

const getAccountEvents = async (accountId, userToken) => {
	const events = await api.get(`/account/events?account_id=${accountId}`, {
		headers: {
			'X-Access-Token': userToken
		}
	});

	return events;
};

const addMedia = async (mediaData, userToken) => {
	const mediaRes = await api.post('/account/media/add', mediaData, {
		headers: {
			'X-Access-Token': userToken
		}
	});

	return mediaRes;
};

const deleteMedia = async (media, userToken) => {
	const mediaRes = await api.post('/account/media/remove', media, {
		headers: {
			'X-Access-Token': userToken
		}
	});

	return mediaRes;
};

const addEvent = async (event, userToken) => {
	const eventRes = await api.post('/event', event, {
		headers: {
			'X-Access-Token': userToken
		}
	});

	return eventRes;
};

const updateEvent = async (event, userToken) => {
	const eventRes = await api.post('/event/update', event, {
		headers: {
			'X-Access-Token': userToken
		}
	});

	return eventRes;
};

const deleteEvent = async (event, userToken) => {
	api.delete('/event', {
		headers: {
			'X-Access-Token': userToken
		},
		data: event
	});
};

const loadEventsPage = async (accountId, pageNumber, userToken) => {
	const res = await api.get(`/account/events?account_id=${accountId}&pg=${pageNumber}`, {
		headers: {
			'X-Access-Token': userToken
		}
	});

	return res.data.events;
};

export const CHANNEL_API = {
	getAccountEvents,
	getAllChannels,
	getUser,
	getAccount,
	addMedia,
	deleteMedia,
	addEvent,
	updateEvent,
	deleteEvent,
	loadEventsPage
};